import { Heading, HStack, Image, Text, VStack} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";

const Card = ({ title, description, imageSrc, url }) => {
  //UI components from Chakra UI
  return(
  <VStack
    color="black"
    backgroundColor="white"
    cursor="pointer"
    borderRadius="xl"
    className="imgCont"
    >
      <Image className='img' src={imageSrc} objectFit='cover'alt='projects'/>
      <VStack spacing={4} p={4} alignItems="flex-start">
        <Heading as='h3' size='md'>{title}</Heading>
        <Text color="#64748b" size="lg">{description}</Text>
        <HStack spacing={2} alignItems="center">
          <a href={url}><Text m={4} color='black'>See more<FontAwesomeIcon icon={faArrowRight} /></Text></a>
        </HStack>
      </VStack>
  </VStack>
  )
}

export default Card;
